import { render } from "./delimiter.vue?vue&type=template&id=f0097774&scoped=true"
const script = {}

import "./delimiter.vue?vue&type=style&index=0&id=f0097774&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0097774"]])

export default __exports__